import { Edit, SimpleForm, TextInput, SelectInput } from 'react-admin';
import { Box, Typography } from '@mui/material';

export const TutoringAgreementEdit = () => (
  <Edit>
    <SimpleForm>
      <Typography variant="h6" sx={{ mb: 1 }}>Agreement Details</Typography>
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 1 }}>
        <TextInput source="agreementNumber" label="Agreement Number" fullWidth />
        <TextInput source="tutorId" label="Tutor ID" fullWidth />
        <TextInput source="clientId" label="Client ID" fullWidth />
        <TextInput source="serviceAuthorisationId" label="Service Authorisation ID" fullWidth />
        <TextInput source="startDate" type="date" fullWidth />
        <TextInput source="endDate" type="date" fullWidth />
        <TextInput source="rate" fullWidth />
        <TextInput source="paymentTerms" label="Payment Terms" fullWidth />
        <SelectInput
          source="status"
          choices={['Draft', 'Active', 'Expired', 'Terminated'].map(s => ({ id: s, name: s }))}
          fullWidth
        />
      </Box>
      <TextInput source="description" multiline rows={3} fullWidth sx={{ mt: 1 }} />
    </SimpleForm>
  </Edit>
);
